/* eslint-disable */

import { State } from "../state";
import { Request } from "@/network/request";
import i18n from "../../i18n";
import toast from "../../plugins/toast";

export default class cities {
  endPoint = "city";
  cities=[]
  tableData = {
    data: [],
    showData: [],
    headers: {
      id: {
        name: "id",
        keys: ["id"],
      },
      en_name: {
        name: "english name",
        keys: ["en_name"],
      },

      ar_name: {
        name: "arabic name",
        keys: ["ar_name"],
      },
      cn_name: {
        name: "chinese name",
        keys: ["cn_name"],
      },
      country_id: {
        name: "country",
        keys: ["country_id"],
      },
    },
    meta: {
      total: 1,
      per_page: 1,
      current_page: 1,
    },
  };
  getState = new State();
  postState = new State();
  editState = new State();
  createState = new State();
  deleteState = new State();

  get(page) {
    let request = new Request({
      method: "get",
      endpoint: `/admin/${this.endPoint}`,
      params: page,
      token: "44|1t0dDaKZNOPq9QZClkRdGugmJoEjAg931FghJZox",
    });

    this.getState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.tableData.data = value.data;
          this.tableData.meta = value.meta;
          this.cities=value.data
        },
        onError: (error) => {
          toast(i18n.t(error.type), { timeout: 4000, rtl: true }, "error");
        },
      }
    );
  }
  async post(payload) {
    let request = new Request({
      method: "post",
      endpoint: `/admin/${this.endPoint}`,
      data: payload,
      token: "44|1t0dDaKZNOPq9QZClkRdGugmJoEjAg931FghJZox",
    });

    await this.postState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          toast(
            i18n.t("create success"),
            { timeout: 4000, rtl: true },
            "sucess"
          );
        },
        onError: (error) => {
          toast(i18n.t(error.type), { timeout: 4000, rtl: true }, "error");
        },
      }
    );
  }
  async edit(payload, id) {
    let request = new Request({
      method: "put",
      endpoint: `/admin/${this.endPoint}/${id}`,
      data: payload,
      token: "44|1t0dDaKZNOPq9QZClkRdGugmJoEjAg931FghJZox",
    });

    await this.editState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          toast(i18n.t("edit success"), { timeout: 4000, rtl: true }, "sucess");
        },
        onError: (error) => {
          toast(i18n.t(error.type), { timeout: 4000, rtl: true }, "error");
        },
      }
    );
  }
  async deleteItem(id) {
    let request = new Request({
      method: "delete",
      endpoint: `admin/${this.endPoint}/${id}`,
      token: "44|1t0dDaKZNOPq9QZClkRdGugmJoEjAg931FghJZox",
    });

    await this.deleteState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          toast(
            i18n.t("delete success"),
            { timeout: 4000, rtl: true },
            "warning"
          );
        },
        onError: (error) => {
          toast(i18n.t(error.type), { timeout: 4000, rtl: true }, "error");
        },
      }
    );
  }
}

export const City = new cities();
